import { queryClient } from '@/lib/react-query';

export function getLabelValue(name: string) {
  const labels = queryClient.getQueryData<any[]>(['labels']);

  return labels?.[name as keyof typeof labels]?.value ?? `#${name}#`;
}
